var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SidbearSettingsGroup',{attrs:{"title":"Label Styles"}},[_c('sid-font',{attrs:{"prefix":"Label","sid":`.--${_vm.section.sid}--form legend`}}),_c('sid-range-slider',{attrs:{"label":"Label Font Size","sid":`.--${_vm.section.sid}--form legend`,"rule-name":"font-size"}}),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Label Font Color")]),_c('sid-color',{attrs:{"sid":`.--${_vm.section.sid}--form legend`,"rule-name":"color"}})],1)]),_c('sid-align',{attrs:{"label":"Label Alignment","sid":`.--${_vm.section.sid}--form legend`,"rule-name":"text-align"}})],1),_c('SidbearSettingsGroup',{attrs:{"title":"Placeholder Styles"}},[_c('sid-font',{attrs:{"prefix":"Placeholder","sid":`.--${_vm.section.sid}--form .input.form-control::placeholder`}}),_c('sid-range-slider',{attrs:{"label":"Placeholder Font Size","sid":`.--${_vm.section.sid}--form .input.form-control::placeholder`,"rule-name":"font-size"},on:{"change":function($event){return _vm.updateSectionStyle('inputPlaceholder.fontSize', $event)}}}),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Placeholder Font Color")]),_c('sid-color',{attrs:{"sid":`.--${_vm.section.sid}--form .input.form-control::placeholder`,"rule-name":"color"},on:{"change":function($event){return _vm.updateSectionStyle('inputPlaceholder.color', $event)}}})],1)])],1),_c('SidbearSettingsGroup',{attrs:{"title":"Input Styles"}},[_c('sid-font',{attrs:{"prefix":"Input","sid":`.--${_vm.section.sid}--form .input.form-control`}}),_c('sid-range-slider',{attrs:{"label":"Input Font Size","sid":`.--${_vm.section.sid}--form .input.form-control`,"rule-name":"font-size"},on:{"change":function($event){return _vm.updateSectionStyle('input.fontSize', $event)}}}),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Input Font Color")]),_c('sid-color',{attrs:{"sid":`.--${_vm.section.sid}--form .input.form-control`,"rule-name":"color"},on:{"change":function($event){return _vm.updateSectionStyle('input.color', $event)}}})],1)]),_c('sid-range-slider',{attrs:{"label":"Input Height","sid":`.--${_vm.section.sid}--form .input.form-control`,"rule-name":"height"}})],1),_c('SidbearSettingsGroup',{attrs:{"title":"Background"}},[_c('rule-tabs',{scopedSlots:_vm._u([{key:"Normal",fn:function(){return [_c('sid-background',{attrs:{"sid":`.--${_vm.section.sid}--form .input.form-control`}})]},proxy:true},{key:"Hover",fn:function(){return [_c('sid-background',{attrs:{"sid":`.--${_vm.section.sid}--form .input.form-control`,"presudo":":hover"}})]},proxy:true}])})],1),_c('SidbearSettingsGroup',{attrs:{"title":"Border & Radius"}},[_c('rule-tabs',{scopedSlots:_vm._u([{key:"Normal",fn:function(){return [_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Border Type")]),_c('sid-select',{staticClass:"w-[118px]",attrs:{"sid":`.--${_vm.section.sid}--form .input.form-control`,"rule-name":"border-style","searchable":false,"options":[
                {
                  label: 'Solid',
                  value: 'solid'
                },
                {
                  label: 'Dashed',
                  value: 'dashed'
                },
                {
                  label: 'Dotted',
                  value: 'dotted'
                },
                {
                  label: 'Double',
                  value: 'double'
                },
                {
                  label: 'Outset',
                  value: 'outset'
                }
              ]}})],1)]),_c('b-form-group',[_c('sid-linked-group',{staticClass:"!mb-[7px]",attrs:{"sid":`.--${_vm.section.sid}--form .input.form-control`,"label":"Border Width","rule-name":"border","angles":[
              {
                text: '',
                value: 'top-width'
              },
              {
                text: '',
                value: 'right-width'
              },
              {
                text: '',
                value: 'bottom-width'
              },
              {
                text: '',
                value: 'left-width'
              }
            ]}}),_c('div',{staticClass:"flex w-full justify-end"},[_c('sid-color',{attrs:{"sid":`.--${_vm.section.sid}--form .input.form-control`,"rule-name":"border-color"}})],1)],1),_c('sid-linked-group',{attrs:{"label":"Radius","sid":`.--${_vm.section.sid}--form .input.form-control`,"rule-name":"border","titles":['top-l', 'top-r', 'bottom-l', 'bottom-r'],"angles":[
            {
              text: '',
              value: 'top-left-radius',
              cssVar: '--border-top-left-radius'
            },
            {
              text: '',
              value: 'top-right-radius',
              cssVar: '--border-top-right-radius'
            },
            {
              text: '',
              value: 'bottom-left-radius',
              cssVar: '--border-bottom-left-radius'
            },
            {
              text: '',
              value: 'bottom-right-radius',
              cssVar: '--border-bottom-right-radius'
            }
          ]}})]},proxy:true},{key:"Hover",fn:function(){return [_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Border Type")]),_c('sid-select',{staticClass:"w-[118px]",attrs:{"sid":`.--${_vm.section.sid}--form .input.form-control`,"rule-name":"border-style","searchable":false,"presudo":":hover","options":[
                {
                  label: 'Solid',
                  value: 'solid'
                },
                {
                  label: 'Dashed',
                  value: 'dashed'
                },
                {
                  label: 'Dotted',
                  value: 'dotted'
                },
                {
                  label: 'Double',
                  value: 'double'
                },
                {
                  label: 'Outset',
                  value: 'outset'
                }
              ]}})],1)]),_c('b-form-group',[_c('sid-linked-group',{staticClass:"!mb-[7px]",attrs:{"sid":`.--${_vm.section.sid}--form .input.form-control`,"label":"Border Width","rule-name":"border","presudo":":hover","angles":[
              {
                text: '',
                value: 'top-width'
              },
              {
                text: '',
                value: 'right-width'
              },
              {
                text: '',
                value: 'bottom-width'
              },
              {
                text: '',
                value: 'left-width'
              }
            ]}}),_c('div',{staticClass:"flex w-full justify-end"},[_c('sid-color',{attrs:{"sid":`.--${_vm.section.sid}--form .input.form-control`,"rule-name":"border-color","presudo":":hover"}})],1)],1),_c('sid-linked-group',{attrs:{"label":"Radius","sid":`.--${_vm.section.sid}--form .input.form-control`,"rule-name":"border","titles":['top-l', 'top-r', 'bottom-l', 'bottom-r'],"presudo":":hover","angles":[
            {
              text: '',
              value: 'top-left-radius',
              cssVar: '--border-top-left-radius'
            },
            {
              text: '',
              value: 'top-right-radius',
              cssVar: '--border-top-right-radius'
            },
            {
              text: '',
              value: 'bottom-left-radius',
              cssVar: '--border-bottom-left-radius'
            },
            {
              text: '',
              value: 'bottom-right-radius',
              cssVar: '--border-bottom-right-radius'
            }
          ]}})]},proxy:true}])})],1),_c('SidbearSettingsGroup',{attrs:{"title":"Drop Shadow"}},[_c('rule-tabs',{scopedSlots:_vm._u([{key:"Normal",fn:function(){return [_c('b-form-group',{staticClass:"mb-0",attrs:{"label":"Shadow Color"}},[_c('sid-box-shadow',{attrs:{"sid":`.--${_vm.section.sid}--form .form-control.input`,"rule-name":"box-shadow"}})],1)]},proxy:true},{key:"Hover",fn:function(){return [_c('b-form-group',{staticClass:"mb-0",attrs:{"label":"Shadow Color"}},[_c('sid-box-shadow',{attrs:{"sid":`.form-control.input`,"rule-name":"box-shadow","presudo":":hover"}})],1)]},proxy:true}])})],1),_c('SidbearSettingsGroup',{attrs:{"title":"Padding, Margins & Gaps"}},[_c('sid-linked-group',{attrs:{"label":"Padding","sid":`.--${_vm.section.sid}--form .form-control.input`,"rule-name":"padding","min":0,"angles":[
        {
          text: '',
          value: 'top'
        },
        {
          text: '',
          value: 'right'
        },
        {
          text: '',
          value: 'bottom'
        },
        {
          text: '',
          value: 'left'
        }
      ]}}),_c('sid-linked-group',{attrs:{"label":"Margin","sid":`.--${_vm.section.sid}--form .form-margin`,"rule-name":"margin","min":-2000,"max":2000,"angles":[
        {
          text: '',
          value: 'top'
        },
        {
          text: '',
          value: 'right'
        },
        {
          text: '',
          value: 'bottom'
        },
        {
          text: '',
          value: 'left'
        }
      ]}}),_c('sid-range-slider',{attrs:{"label":"Horizontal Gap","sid":`.--${_vm.section.sid}--content .--${_vm.section.sid}--form`,"rule-name":"column-gap"}}),_c('sid-range-slider',{attrs:{"label":"Vertical Gap","sid":`.--${_vm.section.sid}--content .--${_vm.section.sid}--form`,"rule-name":"row-gap"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }